import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  IconButton,
  Box,
  Menu,
  MenuItem,
  Avatar,
  Container,
} from '@mui/material';
import {
  Menu as MenuIcon,
  AccountCircle,
  Login,
  PersonAdd,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Header = () => {
  const navigate = useNavigate();
  const { isAuthenticated, user, logout } = useAuth();
  const [anchorEl, setAnchorEl] = useState(null);
  const [mobileAnchorEl, setMobileAnchorEl] = useState(null);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    logout();
    handleClose();
  };

  return (
    <AppBar position="sticky" sx={{ backgroundColor: 'primary.main' }}>
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          {/* Logo */}
          <Typography
            variant="h5"
            noWrap
            component="div"
            onClick={() => navigate('/')}
            sx={{
              flexGrow: 0,
              fontWeight: 700,
              cursor: 'pointer',
              mr: 4,
            }}
          >
            🍽️ Koopjesjacht
          </Typography>

          {/* Navigation Links */}
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
            <Button
              color="inherit"
              onClick={() => navigate('/hunts')}
              sx={{ mx: 1 }}
            >
              Browse Hunts
            </Button>
            <Button color="inherit" onClick={() => navigate('/offerings')} sx={{ mx: 1 }}>
              For partners
            </Button>
            <Button
              color="inherit"
              onClick={() => navigate('/#how-it-works')}
              sx={{ mx: 1 }}
            >
              How It Works
            </Button>
            {isAuthenticated && ['hunter','organizer','admin'].includes(user?.role) && (
              <Button color="inherit" onClick={() => navigate('/venue-discovery')} sx={{ mx: 1 }}>
                Recommend Venues
              </Button>
            )}
          </Box>

          <IconButton color="inherit" aria-label="open navigation" onClick={(event) => setMobileAnchorEl(event.currentTarget)} sx={{ display: { xs: 'inline-flex', md: 'none' }, ml: 'auto' }}>
            <MenuIcon />
          </IconButton>
          <Menu anchorEl={mobileAnchorEl} open={Boolean(mobileAnchorEl)} onClose={() => setMobileAnchorEl(null)}>
            <MenuItem onClick={() => { navigate('/hunts'); setMobileAnchorEl(null); }}>Browse Hunts</MenuItem>
            <MenuItem onClick={() => { navigate('/offerings'); setMobileAnchorEl(null); }}>For partners</MenuItem>
            {isAuthenticated && ['hunter','organizer','admin'].includes(user?.role) && <MenuItem onClick={() => { navigate('/venue-discovery'); setMobileAnchorEl(null); }}>Recommend Venues</MenuItem>}
          </Menu>

          {/* Auth Buttons */}
          <Box sx={{ flexGrow: 0, ml: { xs: 0, md: 1 } }}>
            {isAuthenticated ? (
              <>
                <IconButton
                  size="large"
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={handleMenu}
                  color="inherit"
                >
                  {user?.avatar_url ? (
                    <Avatar src={user.avatar_url} alt={user.name} />
                  ) : (
                    <AccountCircle />
                  )}
                </IconButton>
                <Menu
                  id="menu-appbar"
                  anchorEl={anchorEl}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                >
                  <MenuItem onClick={() => { navigate('/profile'); handleClose(); }}>
                    Profile
                  </MenuItem>
                  <MenuItem onClick={() => { navigate(user?.role === 'admin' ? '/admin/dashboard' : user?.role === 'organizer' ? '/organizer/dashboard' : ['shop_owner','shop_employee'].includes(user?.role) ? '/venue/dashboard' : '/hunts'); handleClose(); }}>
                    My Dashboard
                  </MenuItem>
                  <MenuItem onClick={handleLogout}>Logout</MenuItem>
                </Menu>
              </>
            ) : (
              <>
                <Button
                  color="inherit"
                  startIcon={<Login />}
                  onClick={() => navigate('/login')}
                  sx={{ mx: 1 }}
                >
                  Login
                </Button>
                <Button
                  variant="contained"
                  color="secondary"
                  startIcon={<PersonAdd />}
                  onClick={() => navigate('/register')}
                  sx={{ mx: 1 }}
                >
                  Sign Up
                </Button>
              </>
            )}
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header;
